// External libraries
import gql from 'graphql-tag';

export const BUYER_FRAGMENT = gql`
  fragment buyer on CheckoutSession {
    buyer {
      auth {
        accessToken
      }
      userId
    }
  }
`;
